/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import { createApp } from 'vue';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
window.axios.defaults.transformRequest = function (data, headers) {
    try {
        if (data instanceof FormData === false && data) {
            let formData = new FormData();

            Object.entries(data).forEach(([key, value]) => {
                if (typeof value === 'object') {
                    // create multidimensional array
                    for(let i in value) {
                        formData.append(`${key}[${i}]`, value[i] || null);
                    }
                } else if (value instanceof File) {
                    // add file type
                    formData.append(key, value, value.name);
                } else {
                    formData.append(key, value || null);
                }
            })
            return formData;
        }
        return data;
    } catch (err) {
        console.error(err);
    }
};

import Autocomplete from 'v-autocomplete';

window.$ = window.jQuery = require('jquery');
window.createApp = createApp;

import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);
window.Swiper = Swiper;

window.Core = require('./libs/Core');
import AppVue from './libs/App';
window.AppVue = AppVue;
// App.debug = true;


// Глобальные плагины и миксины теперь добавляются в каждое приложение отдельно
window.globalPlugins = {
    Autocomplete,
    screenWidthMixin: require('./mixins/screenWidth/screenWidth').default
};